import React from "react";
import hero from "../../assets/images/hero.png";
export default function RightPart() {
    return (
        <div>
            <img src={hero} className=" border" alt="" />
        </div>
    );
}
